export const coursesHero = {
  title: 'Computer Skills Courses',
  subtitle: 'From digital literacy to advanced programming — we equip Pulau Pinang youth with the tech skills needed for tomorrow\'s workforce.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20computer%20lab%20with%20Malaysian%20youth%20learning%20coding%2C%20bright%20classroom%2C%20laptops%20on%20desks%2C%20engaged%20students%2C%20professional%20setting%2C%20natural%20lighting&width=1600&height=800&seq=hero-courses&orientation=landscape',
};

export const courseCategories = [
  { id: 'all', label: 'All Courses' },
  { id: 'basic', label: 'Basic Literacy' },
  { id: 'intermediate', label: 'Intermediate' },
  { id: 'advanced', label: 'Advanced' },
];

export const coursesList = [
  {
    id: 'digital-literacy',
    title: 'Digital Literacy Fundamentals',
    category: 'basic',
    duration: '8 Weeks',
    schedule: 'Saturdays, 9:00 AM - 12:00 PM',
    level: 'Beginner',
    description: 'Master the essentials of using computers — from typing and file management to internet navigation, email, and online safety. Perfect for youth with little to no computer experience.',
    topics: ['Computer basics & typing', 'File management & organization', 'Internet navigation & search', 'Email communication', 'Online safety & privacy', 'Introduction to productivity tools'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Malaysian%20students%20learning%20basic%20computer%20skills%20in%20classroom%2C%20simple%20desktop%20computers%2C%20instructor%20demonstrating%2C%20bright%20natural%20light%2C%20supportive%20learning%20environment%2C%20clean%20aesthetic&width=600&height=600&seq=course-digital-literacy&orientation=squarish',
  },
  {
    id: 'office-productivity',
    title: 'Office Productivity Suite',
    category: 'basic',
    duration: '6 Weeks',
    schedule: 'Sundays, 10:00 AM - 1:00 PM',
    level: 'Beginner',
    description: 'Learn to use word processors, spreadsheets, and presentation software confidently. These are the core tools used in nearly every office job in Malaysia.',
    topics: ['Microsoft Word & Google Docs', 'Excel & Google Sheets basics', 'PowerPoint & presentation design', 'Document formatting & printing', 'Basic data entry & formulas', 'Professional communication'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Students%20learning%20office%20productivity%20software%20in%20modern%20computer%20lab%2C%20Malaysian%20youth%20working%20on%20spreadsheets%2C%20focused%20expressions%2C%20bright%20classroom%2C%20professional%20setting&width=600&height=600&seq=course-office-productivity&orientation=squarish',
  },
  {
    id: 'web-development',
    title: 'Introduction to Web Development',
    category: 'intermediate',
    duration: '12 Weeks',
    schedule: 'Saturdays, 2:00 PM - 5:00 PM',
    level: 'Intermediate',
    description: 'Build your first websites from scratch! Learn HTML, CSS, and JavaScript fundamentals, then deploy real projects. Prerequisite: basic computer literacy.',
    topics: ['HTML5 structure & semantics', 'CSS3 styling & layout', 'Responsive design principles', 'JavaScript fundamentals', 'Version control with Git', 'Final project: Personal portfolio site'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Malaysian%20developers%20learning%20web%20development%20on%20laptops%2C%20code%20on%20screens%2C%20modern%20workspace%2C%20collaborative%20learning%2C%20bright%20natural%20lighting%2C%20clean%20tech%20environment&width=600&height=600&seq=course-web-development&orientation=squarish',
  },
  {
    id: 'digital-marketing',
    title: 'Digital Marketing Essentials',
    category: 'intermediate',
    duration: '8 Weeks',
    schedule: 'Sundays, 2:00 PM - 5:00 PM',
    level: 'Intermediate',
    description: 'Understand social media marketing, content creation, and basic analytics. Learn how businesses grow online and how you can build a career in digital marketing.',
    topics: ['Social media strategy', 'Content creation & copywriting', 'Canva & graphic design basics', 'Facebook & Instagram ads', 'Google Analytics introduction', 'Building a marketing portfolio'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20marketing%20workshop%20for%20youth%2C%20students%20analyzing%20social%20media%20data%20on%20laptops%2C%20colorful%20marketing%20materials%2C%20modern%20classroom%2C%20creative%20atmosphere%2C%20Malaysian%20participants&width=600&height=600&seq=course-digital-marketing&orientation=squarish',
  },
  {
    id: 'advanced-programming',
    title: 'Advanced Programming with Python',
    category: 'advanced',
    duration: '16 Weeks',
    schedule: 'Saturdays, 9:00 AM - 1:00 PM',
    level: 'Advanced',
    description: 'Dive deep into Python programming — from data structures to building real applications. This course prepares youth for software development careers and further studies in IT.',
    topics: ['Python syntax & data structures', 'Object-oriented programming', 'Database integration with SQL', 'Building REST APIs', 'Version control & collaboration', 'Capstone project: Real-world application'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Advanced%20programming%20class%20with%20Malaysian%20students%20coding%20in%20Python%2C%20multiple%20monitors%20showing%20code%2C%20modern%20tech%20lab%2C%20concentrated%20expressions%2C%20professional%20setting%2C%20clean%20lighting&width=600&height=600&seq=course-advanced-programming&orientation=squarish',
  },
  {
    id: 'cybersecurity',
    title: 'Cybersecurity Awareness & Basics',
    category: 'intermediate',
    duration: '6 Weeks',
    schedule: 'Sundays, 9:00 AM - 12:00 PM',
    level: 'Intermediate',
    description: 'Learn how to stay safe online and understand the fundamentals of cybersecurity. Covering password management, phishing detection, network security basics, and ethical hacking introduction.',
    topics: ['Password security & management', 'Recognizing phishing & scams', 'Network security basics', 'Ethical hacking introduction', 'Data privacy fundamentals', 'Security tools & practices'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Cybersecurity%20training%20session%20with%20youth%20learning%20network%20security%2C%20laptops%20with%20security%20dashboards%2C%20modern%20classroom%2C%20serious%20focused%20expressions%2C%20digital%20lock%20visuals%2C%20professional%20environment&width=600&height=600&seq=course-cybersecurity&orientation=squarish',
  },
];

export const courseStats = [
  { value: '300+', label: 'Students Trained' },
  { value: '12+', label: 'Courses Delivered' },
  { value: '85%', label: 'Job Placement Rate' },
  { value: '6', label: 'Active Courses' },
];

export const courseFAQ = [
  {
    question: 'Who can join the courses?',
    answer: 'Our courses are open to youth aged 16-30 residing in Pulau Pinang. No prior experience is required for beginner-level courses. For intermediate and advanced courses, some prerequisites may apply.',
  },
  {
    question: 'How much do the courses cost?',
    answer: 'All our courses are completely free for eligible participants, thanks to donations and community support. We believe financial circumstances should never be a barrier to quality education.',
  },
  {
    question: 'Do I need my own laptop?',
    answer: 'We provide computers and all necessary equipment at our training center. However, participants are welcome to bring their own laptops if they prefer.',
  },
  {
    question: 'Will I receive a certificate?',
    answer: 'Yes! Participants who complete a course with satisfactory attendance and project submissions will receive a certificate of completion from PERTUBUHAN INSAN PERWIRA PULAU PINANG.',
  },
];